<div class="no-teams-info">
  <h3>{{ 'END_CONS_SIGN_UP.NO_TEAMS.TITLE' | translate }}</h3>
  <div class="body-text">
    <p [innerHTML]="'END_CONS_SIGN_UP.NO_TEAMS.BODY' | translate: { city: city }"></p>
  </div>
  <p class="description">{{ 'END_CONS_SIGN_UP.NO_TEAMS.DESCRIPTION' | translate }}</p>

  <div class="buttons-wrap mt-4">
    <a [href]="appleStoreLink" class="store-btn apple" target="_blank"></a>
    <a [href]="googlePlayLink" class="store-btn android" target="_blank"></a>
  </div>

  <button class="btn btn-primary mt-5" (click)="closeModal()">{{ 'END_CONS_SIGN_UP.NO_TEAMS.CLOSE' | translate }}</button>
</div>

